<template>
  <div class="tabs">
    <el-button icon="el-icon-d-arrow-left" @click="goBack" v-if="isShowBack">{{ $t('msg.Back') }}</el-button>
    <el-divider direction="vertical" v-if="isShowBack"></el-divider>
    <el-tag type="success" style="font-size: 14px;" size="medium"> {{ nowTagName }} </el-tag>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: "CommonTag",
  data() {
    return {
      tab: [
        {
          path: '/updatePassword',
          name: 'updatePassword',
          label: this.$t('msg.Change_Password'),
          icon: 's-check',
          url: 'updatePassword',
          show: true
        },
        {
          path: '/updatePrivateAside',
          label: this.$t('msg.Change_personal_2_Password'),
          show: true
        },
        {
          path: '/accountList',
          label: this.$t('msg.user_management'),
          show: true
        },
        {
          path: '/editUser',
          label: this.$t('msg.Edit_User'),
          show: false
        },
        {
          path: '/editProxy',
          label: this.$t('msg.Edit_agent'),
          show: false
        },
        {
          path: '/setScore',
          label: this.$t('msg.Set_score1'),
          show: false
        },
        {
          path: '/setScoreLog',
          label: this.$t('msg.score_log'),
          show: true
        },
        {
          path: '/queryReport',
          label: this.$t('msg.report'),
          show: false
        },
        {
          path: '/allQueryReport',
          label: this.$t('msg.General_ledger_audit'),
          show: false
        },
        {
          path: '/userSearch',
          label: this.$t('msg.Search_Account'),
          show: true
        },
        {
          path: '/playerBetLog',
          label: this.$t('msg.game_log'),
          show: true
        },
        {
          path: '/bonusLog',
          label: this.$t('msg.Bonus_log'),
          show: true
        },
        {
          path: '/subAccount',
          label: this.$t('msg.Sub_account_management'),
          show: true
        },
        {
          path: '/ranking',
          label: this.$t('msg.ranking'),
          show: true
        },
        {
          path: '/updateSubProxy',
          label: this.$t('msg.Modify_subaccount_permissions'),
          show: false
        },
        {
          path: '/userIdPool',
          label: 'ID池管理',
          show: true
        },
        {
          path: '/adminUpdatePwd',
          label: '修改代理密码',
          show: false
        },
        {
          path: '/fortuneTiger',
          label: 'Fortune Tiger',
          show: false
        },
        {
          path: '/ganeshaCash',
          label: 'Ganesha Cash',
          show: false
        },
        {
          path: '/blazing',
          label: '777 Blazing',
          show: false
        },
        {
          path: '/buffalo',
          label: 'Buffalo',
          show: false
        },
        {
          path: '/cashMachine',
          label: 'Cash Machine',
          show: false
        },
        {
          path: '/tripleRedHot777',
          label: 'Triple Red Hot 777',
          show: false
        },
        {
          path: '/bengalTreasure',
          label: 'Bengal Treasure',
          show: false
        },
        {
          path: '/blackWolf',
          label: 'BLACK WOLF',
          show: false
        },
        {
          path: '/fortuneOx',
          label: 'FORTUNE OX',
          show: false
        },
        {
          path: '/fortuneRabbit',
          label: 'FORTUNE RABBIT',
          show: false
        },
        {
          path: '/diamondHearts',
          label: 'Diamond Hearts',
          show: false
        },
        {
          path: '/cricketFever',
          label: 'Cricket Fever',
          show: false
        },
        {
          path: '/gatesofOlympus',
          label: 'Gates of Olympus',
          show: false
        },
        {
          path: '/devilishDelights',
          label: 'Devilish Delights',
          show: false
        },
        {
          path: '/buffaloDeluxe',
          label: 'Buffalo Deluxe',
          show: false
        },
        {
          path: '/bigBassSplash',
          label: 'BIG BASS SPLASH',
          show: false
        },
        {
          path: '/moneyVault',
          label: 'Money Vault',
          show: false
        },
        {
          path: "/vikingsHammer",
          label: "Viking's Hammer",
          show: false
        },
        {
          path: "/fireIce",
          label: "Fire and Ice",
          show: false
        },
        {
          path: "/rapidStar",
          label: "Rapid Star",
          show: false
        },
        {
          path: '/timberWolfTriplePower',
          label: 'Timber Wolf Triple Power',
          show: false
        },
        {
          path: '/tripleTwister',
          label: 'Triple Twister',
          show: false
        },
        {
          path: '/bonusBears',
          label: 'Bonus Bears',
          show: false
        },
        {
          path: '/crystalWaters',
          label: 'Crystal Waters',
          show: false
        },
        {
          path: '/fairyGardenPlus',
          label: 'Fairy Garden Plus',
          show: false
        },
        {
          path: '/seaWorld',
          label: 'Sea World',
          show: false
        }
      ],
    }
  },
  methods: {
    goBack() {
      var p = this.$route.path
      this.$router.go(-1)
      // setTimeout(() => {
      //   if (p === this.$route.path) {
      //     window.location.reload()
      //   }
      // }, 200)
    }
  },
  computed: {
    ...mapState({
      tags: state => state.tab.tabsList
    }),
    nowTagName() {
      for (var i = 0; i < this.tab.length; i++) {
        if (this.$route.path == this.tab[i].path) {
          if (this.tab[i].path == '/allQueryReport') {
            if (this.$route.query.user_type == 0) {
              return this.$t('msg.Player_total_report')
            } else {
              return this.$t('msg.Agent_total_report')
            }
          }
          return this.tab[i].label
        }
      }
    },
    isShowBack() {
      for (var i = 0; i < this.tab.length; i++) {
        if (this.$route.path == this.tab[i].path) {
          if (['/setScoreLog', '/userSearch', '/playerBetLog', '/bonusLog'].indexOf(this.$route.path) != -1){
            return true
          }
          if(this.$route.path == '/accountList'){
            if (this.$route.query.pid){
              return true
            }else{
              return false
            }
          }
          return !this.tab[i].show
        }
      }
    }
  },

}
</script>

<style lang="less" scoped>
.tabs {
  background: #fff;
  padding: 10px 20px;
  border-bottom: 1px solid #e4e9f0;
  display: flex;
  align-items: center;
  gap: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/CommonTag.vue